export default {
  methods: {
    getUtmParams() {
      const utm_params_names = this.$store.state.utm_params_names

      let utm_params = {}

      utm_params_names.forEach(name => {
        const param = localStorage.getItem(name)
        if (param) utm_params[name] = param
      })

      return utm_params
    },
  },
}
